module.exports = "/lucky-balls/img/header-babaijebu.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/header-babaijebu.png
// module id = 233
// module chunks = 0